/**
 * History Timeline
 * - Gère la progression de la ligne centrale
 * - Active l'item courant en fonction du scroll
 * - Révèle progressivement les contenus (fade + translate)
 */

(function () {
  function initHistoryTimeline(root) {
    if (!root) return;

    const items = Array.from(root.querySelectorAll('.js-history-item'));
    const progressEl = root.querySelector('.js-history-progress');

    if (!items.length || !progressEl) return;

    // ------------------------------------------------------------
    // 1) Révélation progressive (IntersectionObserver)
    // ------------------------------------------------------------
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2
      }
    );

    root
      .querySelectorAll('.js-history-content, .js-history-media')
      .forEach((el) => revealObserver.observe(el));

    // ------------------------------------------------------------
    // 2) Progression de la ligne + item actif
    // ------------------------------------------------------------
    function updateTimeline() {
      const rect = root.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;

      // On définit une "fenêtre active" dans le viewport
      const startZone = vh * 0.15;
      const endZone = vh * 0.85;
      const totalScrollable = rect.height - (endZone - startZone);

      let progress = 0;

      if (rect.top >= startZone) {
        progress = 0;
      } else if (rect.bottom <= endZone) {
        progress = 1;
      } else {
        const distance = startZone - rect.top;
        progress = totalScrollable > 0 ? distance / totalScrollable : 0;
        progress = Math.max(0, Math.min(1, progress));
      }

      // Applique la progression à la ligne (scaleY)
      progressEl.style.transform = 'scaleY(' + progress + ')';

      // Détermine l'item "actif" à partir de cette progression
      if (items.length > 0) {
        const index = Math.round(progress * (items.length - 1));
        items.forEach((item, i) => {
          item.classList.toggle('is-active', i === index);
        });
      }
    }

    // ------------------------------------------------------------
    // 3) Listeners scroll / resize
    // ------------------------------------------------------------
    const onScroll = () => window.requestAnimationFrame(updateTimeline);
    const onResize = () => window.requestAnimationFrame(updateTimeline);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    // Premier calcul
    updateTimeline();
  }

  // Auto-init sur tous les blocs portant data-history-timeline
  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('[data-history-timeline]')
      .forEach((el) => initHistoryTimeline(el));
  });
})();
